module.exports = __webpack_public_path__ + "img/teacher-bg.dd1f36e.png";